import { makeStyles } from '@material-ui/core';
import { NextTheme } from '../../../../layout/theme-next/provider';
import Colors from '../../../../layout/theme/utils/colors';

export default makeStyles<NextTheme>(theme => ({
  root: {
    backgroundColor: Colors.latest_red_varient,
    color: Colors.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: theme.typography.fontWeightBold,
    padding: theme.spacing(1),
    margin: theme.spacing(0, 1.25, 1.25),
    borderRadius: theme.shape.borderRadius,
    position: 'sticky',
    top: 0,
    zIndex: 5,
    gap: theme.spacing(0.5),
  },
  regular: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  linkBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${Colors.white}`,
    borderRadius: theme.shape.borderRadius,
    marginLeft: theme.spacing(1),
    padding: theme.spacing(0.25),
    color: Colors.white,
    textDecoration: 'none',
    lineHeight: 0,
  },
  icon: {
    fontSize: 16,
  },
}));
